export default {
  请选择您购入的产品: "请选择您购入的产品",
  产品选择: "产品选择",
  上一步: "上一步",
  问题选择: "问题选择",
  提示: "不巧没有找到相匹配的的情况？",
  找不到: "找不到对应问题？",
  点击这里: "点击这里 ›",
  联系方式: "点击这里联系我们 ›",
  提示2:
    "感谢您的配合，只需要最后一步我们就可以收到您的请求啦！您可以通过以下联系方式将页面截图回传给我们的客服，以便我们第一时间处理您的case",
  联系我们: "联系我们",
  提示标题: "提示",
  支持: "Tineco 支持",
};
